import { i18n } from "../../../boot/i18n.js";

export default {
  routes: [
    {
      name: "customer-invoice",
      path: "invoices/:invoiceID",
      props: true,
      meta: {
        icon: "invoice",
        title: (route) => i18n.global.tc("Invoice"),
        crumbs: ["customer-invoices"],
      },
      component: () => import("pages/customer/invoices/Invoice"),
    },
    {
      name: "customer-invoices",
      path: "invoices",
      props: true,
      meta: {
        icon: "invoice",
        title: (route) => i18n.global.tc("Invoice", 100),
        widget: "CustomerInvoices",
      },
      component: () => import("pages/customer/Home"),
    },
  ],

  dialogs: [],
};
